export enum ImageUsageType {
	colorMatchTemplate = "color-match-template",
}

export interface ImageDTO {
	imageId: string
	userId: string
	createdAt: string
	updatedAt: string
	name: string
	orderScore: number
	schemaVersion: number
	contentUrl: string
	contentType: string
	contentDigest: string
	usageType: ImageUsageType
}

export interface CreateImageRequestDTO {
	imageId?: string
	createdAt?: Date
	name: string
	contentUrl: string
	contentType: string
	contentDigest: string
	usageType: ImageUsageType
}
